import { useRouter } from "@tanstack/react-router";

import { clearStoredConversation } from "@/lib/order-assistant/storage";
import { useProfile } from "@/queries/customer/customer";
import { queryClient } from "@/queries/queryClient";
import { useEffect } from "react";
import { AUTH_CHANNEL, isLoggedOutEvent } from "./broadcast";

export function AuthRouterObserver() {
  const { status } = useProfile();
  const router = useRouter();

  useEffect(() => {
    if (status === "error") {
      // User is not authenticated, invalidate router
      queryClient.clear();
      router.invalidate();
    }
  }, [status, router]);

  // Listen for logout broadcasts from other tabs
  useEffect(() => {
    const channel = new BroadcastChannel(AUTH_CHANNEL);

    channel.onmessage = (event) => {
      if (isLoggedOutEvent(event)) {
        // Another tab logged out - clear local state
        clearStoredConversation();
        queryClient.clear();
        router.invalidate();
      }
    };

    return () => channel.close();
  }, [router]);

  return null;
}
